define('store-helper-get-props',['exports', 'helper-content-getQuizGame'], function (exports, _helperContentGetQuizGame) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _helperContentGetQuizGame2 = _interopRequireDefault(_helperContentGetQuizGame);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var getProps = function getProps(app, training, content, userAnswers) {

        var components = content.components || {};

        if (!content) {
            return {};
        }

        var isModularMenuPage = training.modularMenuPageID && content.ID === training.modularMenuPageID ? true : false,
            isQuizPage = content.typeID === 19 ? true : false,
            isQuizSubpage = function (ID, containerID) {
            var isInQuiz = function isInQuiz(ID) {
                var entity = training.getEntity(ID);

                if (!entity) {
                    return false;
                }

                if (entity.typeId === 19) {
                    return true;
                } else if (ID === containerID) {
                    return false;
                } else {
                    return isInQuiz(entity.contentEntity.parentId);
                }
            };

            return isQuizPage || ID === containerID ? false : isInQuiz(ID);
        }(content.parentID, app.containerID),
            isQuizGamePage = components.quizgame ? true : false,
            isQuizGameSubpage = isQuizGamePage || content.parentID === app.containerID ? false : function (ID, contentEntities) {
            var game = (0, _helperContentGetQuizGame2.default)(ID, contentEntities);

            return game.isQuizGame ? true : false;
        }(content.ID, training.contentEntities);

        return {
            isContentPage: content.typeID === 10 ? true : false,
            isModularMenuPage: isModularMenuPage,
            isTaskPage: Array.isArray(content.answers) && content.answers.length || Array.isArray(content.questions) && content.questions.length ? true : false,
            isQuizPage: isQuizPage,
            isQuizSubpage: isQuizSubpage,
            isQuizGamePage: isQuizGamePage,
            isQuizGameSubpage: isQuizGameSubpage,
            isInactive: isModularMenuPage || isQuizPage || isQuizSubpage || userAnswers.isPageVisited(content.ID) || isQuizGamePage || isQuizGameSubpage || !components.navigationsettings || !components.navigationsettings.delay ? false : true
        };
    };

    exports.default = getProps;
});
